export class VolumeSubtitle {
  ID?: number=-1;
  LangName?: string;
  VolumeTitle?: string;
  LangCode?:string="";
  VolumeID?:number;
  VolumeDescription?:string;
  LangDirection?:string;
}